import { render, staticRenderFns } from "./CartWeek.vue?vue&type=template&id=f60666c4&"
import script from "./CartWeek.vue?vue&type=script&lang=js&"
export * from "./CartWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports